// extracted by mini-css-extract-plugin
export default {"control-panel":"styles_control-panel__Gn-0O","control-panel-controls":"styles_control-panel-controls__mlhFo"};